import { CeilingTray } from '@paragon/contract-library';
import { Polygon3D } from '@paragon/geometry-library';

import { SlopedBox } from './slopedBox';

export class CeilingTrayGeometry {
  tray: CeilingTray | Omit<CeilingTray, 'guid'>;

  vertices: SlopedBox;

  faces: readonly Polygon3D[];

  static fromTray(tray: CeilingTray | Omit<CeilingTray, 'guid'>): CeilingTrayGeometry | null {
    const box = SlopedBox.fromDescription(tray);

    return box && CeilingTrayGeometry.fromTrayAndVertices(tray, box);
  }

  private static fromTrayAndVertices(
    tray: CeilingTray | Omit<CeilingTray, 'guid'>,
    vertices: SlopedBox,
  ): CeilingTrayGeometry | null {
    const faces = vertices.facesExcludingBottom;
    return faces && new CeilingTrayGeometry(tray, vertices, faces);
  }

  private constructor(tray: CeilingTray | Omit<CeilingTray, 'guid'>, vertices: SlopedBox, faces: readonly Polygon3D[]) {
    this.tray = tray;
    this.vertices = vertices;
    this.faces = faces;
  }
}
